import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RegistrationService } from '../../services/registration.service';
import { ErrorModalComponent } from '../modals/error-modal/error-modal.component';
import { InfoModalComponent } from '../modals/info-modal/info-modal.component';
import { ResendVerification } from '../modals/resend-verification/resend-verification.component';

@Component({
  selector: 'app-create-credentials',
  templateUrl: './create-credentials.component.html',
  styleUrls: ['./create-credentials.component.scss']
})
export class CreateCredentialsComponent implements OnInit {

  public gemeentes: Array<any> = [];
  public gemeente;
  public schools: Array<any> = [];
  public school;
  public email = '';
  public language;
  public password;
  public confirm_password;
  public signupSubscription: Subscription;

  public languages = JSON.parse(environment.supportedLanguages)

  public projectName = environment.projectName

  @ViewChild('passwordBox', { static: true }) passwordBox: ElementRef;

  constructor(
    private modalService: NgbModal,
    private registrationService: RegistrationService,
    private router: Router,
    private translate: TranslateService
  ) {
  }

  get lang(): string {
    return this.translate.currentLang;
  }

  set lang(value: string) {
    localStorage.setItem('user_lng', value);
    this.language = value;
    this.translate.use(value);
  }


  ngOnInit() {
    if (localStorage.getItem('user_id') && localStorage.getItem('token_info')) {
      this.router.navigate(['/', 'help']);
    }
    this.language = this.lang;
    this.registrationService.getGemeente().pipe(
      map(it => it.children),
    )
      .subscribe(items => this.gemeentes = items.map(it => {
        return {
          value: it.projectID.id,
          label: it.projectName,
          children: it.children
        }
      }));
  }

  public onSelectedGemeentes(parent) {
    this.schools = this.gemeentes.find(it => it.value == parent.value).children.map(it => {
      return {
        value: it.projectID.id,
        label: it.projectName
      }
    }
    );
  }

  emailIsValid(email) {
    return /\S+@\S+\.\S+/.test(email)
  };

  passwordConfirmation() {
    return this.password === this.confirm_password;
  }

  public canBeRegister() {
    return this.email && this.password && this.language && this.emailIsValid(this.email) && this.passwordConfirmation();
  }

  public registration() {
    this.email = this.email.trim();
    if (this.canBeRegister()) {
      this.signupSubscription = this.registrationService.signup(this.email, this.password, this.language).subscribe((res) => {
        const infoDlg = this.modalService.open(InfoModalComponent);
        infoDlg.componentInstance.data = {
          text: 'user signup successfully',
          header: 'Welcome!'
        };
        infoDlg.result.then(() => this.router.navigate(['/login']));
      },
        err => {
          const errDlg = this.modalService.open(ErrorModalComponent);
          let message = 'server_other_error';
          if (err.status === 500) {
            message = 'server_other_error';
          } else {
            message = err.error.error;
          }
          if (err.status === 461) {
            errDlg.componentInstance.header = 'Registration error';
          } else if (err.status === 403) {
            errDlg.componentInstance.header = 'Failure!';
          }
          errDlg.componentInstance.message = message;
        });
    }
  }

  togglePassword(e) {

    if (e.target.classList.contains('fa-eye')) {
      e.target.classList.remove('fa-eye');
      e.target.classList.add('fa-eye-slash');
    }
    else {
      e.target.classList.remove('fa-eye-slash');
      e.target.classList.add('fa-eye');
    }

    if (this.passwordBox.nativeElement.type == 'password') {
      this.passwordBox.nativeElement.setAttribute('type', 'text');
    }
    else {
      this.passwordBox.nativeElement.setAttribute('type', 'password');
    }
  }

  openResendLinkModal() {
    const infoDlg = this.modalService.open(ResendVerification);
    infoDlg.result.then(() => this.router.navigate(['/login']));
  }

  languageChange(selectedLang: string){
    this.language = selectedLang;
  }
}
